import { render, staticRenderFns } from "./StaffGroup.vue?vue&type=template&id=1ff2066b&scoped=true"
import script from "./StaffGroup.vue?vue&type=script&lang=js"
export * from "./StaffGroup.vue?vue&type=script&lang=js"
import style0 from "./StaffGroup.vue?vue&type=style&index=0&id=1ff2066b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff2066b",
  null
  
)

export default component.exports